import { Center } from "./center.types";
import { Command } from "./command.types";
import { SavedFile } from "./files.types";

export enum PurchaseOrderDeliveryType {
  UPS = 'UPS',
  OTHER = 'OTHER',
}

export enum PurchaseOrderStatus {
  READY = "READY",
  IN_DELIVERY = "IN_DELIVERY",
  BLOCKED = "BLOCKED",
  DELIVERED = "DELIVERED",
}

export type PurchaseOrder = {
  id?: number;
  createdAt?: Date;
  updatedAt?: Date;
  shippingAt?: Date;
  externalId: string | null;
  status: PurchaseOrderStatus;
  commandExportId: number | null;
  deliveryType: PurchaseOrderDeliveryType
  commands?: Command[]
  fileId: number | null;
  file: SavedFile;
  shippingLabelFileId: number | null;
  shippingLabelFile: SavedFile;
  trackingId: string | null;
  centerId: Center['id'];
  center: Pick<Center, 'name' | 'id'>;
};
